import { AssetPosition } from '@fdc/types/asset';
import { CoreButton } from '@woolworthslimited/core-components-react/button';

import { FeatureTileProps } from './feature-tile-model';
import styles from './feature-tile.module.scss';

export const FeatureTile: React.FC<FeatureTileProps> = ({
  image,
  imageMobile,
  imageAltText,
  imagePosition = AssetPosition.TOP,
  heading,
  body,
  buttonLabel,
  btnClickHandler,
  buttonAltText,
}) => {
  const altText = imageAltText ?? image.description;
  const directionClass = imagePosition === AssetPosition.TOP ? 'column' : 'row';
  const imageOrderClass =
    imagePosition === AssetPosition.RIGHT ? 'order-last' : 'order-first';

  return (
    <article className={`${styles.featureTile} ${directionClass}`}>
      <div className={`${styles.imageContainer} ${imageOrderClass}`}>
        {image && image.url && (
          <img
            className={styles.imageDesktop}
            src={image.url}
            width={image.width}
            height={image.height}
            alt={altText}
          />
        )}
        {imageMobile && imageMobile.url && (
          <img
            className={styles.imageMobile}
            src={imageMobile.url}
            width={imageMobile.width}
            height={imageMobile.height}
            alt={altText}
          />
        )}
      </div>
      <article className={styles.contentContainer}>
        <h2 className={styles.heading}>{heading}</h2>
        <div className={`${styles.body} richtext`}>{body}</div>
        {buttonLabel && (
          <CoreButton
            as="a"
            label={buttonLabel}
            ariaLabel={`Button Label ${buttonAltText ?? buttonLabel}`}
            clickHandler={btnClickHandler}
          />
        )}
      </article>
    </article>
  );
};
